import React from 'react';
import { motion } from 'framer-motion';
import { Logo2 } from './Logo2';
import { ProgressRail } from './ProgressRail';
import type { Tone } from '../types/snak';
interface SnakShellProps {
  tone: Tone;
  step: number;
  total: number;
  showProgress: boolean;
  children: React.ReactNode;
}
export function SnakShell({
  tone,
  step,
  total,
  showProgress,
  children
}: SnakShellProps) {
  const dark = tone === 'dark';
  return <div className="flex min-h-screen w-full justify-center bg-[#071A16] font-body antialiased" data-id="element-246" data-mp="1v77kahw8vmt">
      <motion.div className="relative flex min-h-screen w-full max-w-[440px] flex-col overflow-hidden" animate={{
      backgroundColor: dark ? '#01332b' : '#FBF7F0'
    }} transition={{
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-247" data-mp="6u1wzvad9ifw">
        {/* ambient brand shapes */}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-248" data-mp="3f7r3dag7gyo8">
          <motion.div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-secondary blur-3xl" animate={{
          opacity: dark ? 0.14 : 0.45
        }} transition={{
          duration: 0.7
        }} data-id="element-249" data-mp="3j9cbkihsoos3" />
          <motion.div className="absolute -bottom-28 -left-20 h-72 w-72 rounded-full bg-primary blur-3xl" animate={{
          opacity: dark ? 0.12 : 0.16
        }} transition={{
          duration: 0.7
        }} data-id="element-250" data-mp="3v1llv9uduflo" />
        </div>

        <header className="relative z-10 px-6 pb-3 pt-6" data-id="element-251" data-mp="3gbxmwf9obt14">
          <div className="flex items-center justify-between" data-id="element-252" data-mp="3gdihu5zwhdzi">
            <div className="flex items-center gap-2.5" data-id="element-253" data-mp="3cacd52sfruv5">
              <Logo2 size="sm" alt="Solventum" className="shrink-0" data-id="element-254" data-mp="3ccym96uz6ifh" />
              <span className={['font-heading text-[15px] tracking-[-0.01em]', dark ? 'text-white' : 'text-background'].join(' ')} data-id="element-255" data-mp="37c13ot61zmdg">
                Solventum
              </span>
            </div>
            <span className={['font-body text-[10px] uppercase tracking-[0.22em]', dark ? 'text-primary' : 'text-[rgba(1,51,43,0.45)]'].join(' ')} data-id="element-256" data-mp="10m30wbcb36w4">
              Filtek Snak
            </span>
          </div>
          {showProgress && <div className="mt-4" data-id="element-257" data-mp="2l4n99pb0v02g">
              <ProgressRail step={step} total={total} tone={tone} data-id="element-258" data-mp="2l1998nptz2y6" />
            </div>}
        </header>

        <main className="relative z-10 flex flex-1 flex-col px-6 pb-8 pt-2" data-id="element-259" data-mp="3ds0z73gayvd2">{children}</main>
      </motion.div>
    </div>;
}